import { MdsIconKind } from "@/design-system/components/icon";
import { getIconKind } from "@/design-system/components/item-list/rows/icon/icon-kind";
import styled from "@emotion/styled";
import { MDSIconButton, MDSIconButtonVariant, MDSTheme } from "@/mds";

interface Props {
  isSelected?: boolean;
  isHighlighted?: boolean;
  toggleSelected?: (event: React.MouseEvent) => void;
  color?: ({ theme }: { theme: MDSTheme }) => string;
  defaultIcon?: MdsIconKind;
}

export function SearchIcon({
  isSelected,
  isHighlighted,
  toggleSelected,
  color,
  defaultIcon = MdsIconKind.Search,
}: Props) {
  return (
    <StyledIconButton
      onClick={toggleSelected}
      variant={MDSIconButtonVariant.Transparent}
      iconKind={getIconKind({ isSelected, isHighlighted, defaultIcon })}
      $isSelected={isSelected}
      $color={color}
    />
  );
}

const StyledIconButton = styled(MDSIconButton)<{
  $isSelected?: boolean;
  $color?: ({ theme }: { theme: MDSTheme }) => string;
}>`
  padding: 0px;
  height: 16px;
  width: 16px;

  .mds-icon {
    font-size: 18px;
    color: ${({ $isSelected, $color, theme }) =>
      $isSelected
        ? theme.colors.mblue.x500
        : ($color?.({ theme }) ?? theme.colors.icon.placeholder)};
    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
`;
